import { render, staticRenderFns } from "./ToplamERPMusteriSayisi.vue?vue&type=template&id=0ad05fa0&scoped=true"
import script from "./ToplamERPMusteriSayisi.vue?vue&type=script&lang=js"
export * from "./ToplamERPMusteriSayisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad05fa0",
  null
  
)

export default component.exports